export default "__VITE_ASSET__158683c2__"